import React from 'react'
import style from '../../../styles/mystyle.module.css'
import Order from './Order'
import { Navbar } from '../Layout/Navbar'
function Main(props) {
  return (
    <div className={style.ContainerMargin + " " + style.BgWeb} >
      <Navbar showDownloadAppSection={false} exchangeAllCurrenciesCallBack={(res)=>(res)} currenciesCallBack={(res)=>(res)}>
        <Order/>
      </Navbar>
    </div>
  )
}

export default Main
